import * as msal from "@azure/msal-browser";

const appUrl = process.env.VUE_APP_URL;
const clientId = process.env.VUE_APP_MSAL_CLIENT_ID;
const tenantId = process.env.VUE_APP_MSAL_TENANT_ID;
const redirectUri = [appUrl, "/login"].join("");

const authority = ["https://login.microsoftonline.com", tenantId, "oauth/v2.0/token"].join("/");

const msalInstance = new msal.PublicClientApplication({
	auth: {
		clientId,
		authority,
		redirectUri
	},
	cache: {
		cacheLocation: "localStorage"
	}
});

export abstract class MSALService {
	public static async login(): Promise<msal.AuthenticationResult> {
		await msalInstance.initialize();
		const loginResponse = await msalInstance.loginPopup({
			scopes: [`${clientId}/.default`]
		});

		// set active account
		const { account } = loginResponse;
		msalInstance.setActiveAccount(account);

		return loginResponse;
	}

	public static async logout(): Promise<void> {
		await msalInstance.initialize();
		const activeAccount = msalInstance.getActiveAccount();

		if (activeAccount) {
			await msalInstance.logoutRedirect({
				account: activeAccount,
				onRedirectNavigate() {
					return false;
				}
			});
		}
	}
}
